import "core-js/modules/es.string.small.js";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import * as React from "react";
import { TextField, Icon, IconConstants, IconButton, RaiseColors, ClearButton, ButtonSizeEnum } from "componentLibrary";
import { makeStyles } from "@mui/styles";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    wrapper: {
      position: "relative"
    },
    iconButton: {
      position: "absolute",
      bottom: "8px",
      right: "8px"
    },
    secondaryIconButton: {
      position: "absolute",
      bottom: "8px",
      right: "40px"
    }
  };
});
var NoteTextField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? "create" : _ref$mode,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 4000 : _ref$maxLength,
    _ref$minRows = _ref.minRows,
    minRows = _ref$minRows === void 0 ? 4 : _ref$minRows,
    _ref$maxRows = _ref.maxRows,
    maxRows = _ref$maxRows === void 0 ? 7 : _ref$maxRows,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var classes = useStyles();
  var isEditMode = mode === "edit";
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      onSubmit();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classes.wrapper,
    ref: ref,
    children: [/*#__PURE__*/_jsx(TextField, {
      inputProps: {
        maxLength: maxLength
      },
      placeholder: placeholder,
      variant: "outlined",
      fullWidth: true,
      multiline: true,
      maxRows: isMobile ? 4 : maxRows,
      minRows: minRows,
      sx: {
        "& .MuiOutlinedInput-root": {
          padding: isEditMode ? "8px 64px 8px 16px" : "8px 32px 8px 16px",
          borderRadius: "8px",
          "&.Mui-focused fieldset": {
            borderColor: RaiseColors.bahama1200
          }
        },
        "& .MuiInputBase-input": {
          fontSize: "14px",
          lineHeight: "20px"
        },
        "& .MuiInputBase-input::placeholder": {
          color: RaiseColors.grayscale900,
          opacity: 1,
          fontSize: "14px",
          lineHeight: "20px"
        }
      },
      value: value,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      onKeyDown: handleKeyDown,
      disabled: disabled
    }), isEditMode ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(IconButton, {
        className: classes.iconButton,
        onClick: onSubmit,
        size: "small",
        disabled: disabled || !(value !== null && value !== void 0 && _trimInstanceProperty(value).call(value)),
        children: /*#__PURE__*/_jsx(Icon, {
          fontSize: 16,
          className: IconConstants.CHECK
        })
      }), /*#__PURE__*/_jsx(ClearButton, {
        className: classes.secondaryIconButton,
        onClick: onCancel !== null && onCancel !== void 0 ? onCancel : function () {},
        size: ButtonSizeEnum.small
      })]
    }) : /*#__PURE__*/_jsx(IconButton, {
      className: classes.iconButton,
      onClick: onSubmit,
      size: "small",
      disabled: disabled,
      children: /*#__PURE__*/_jsx(Icon, {
        fontSize: 16,
        className: IconConstants.PAPER_PLANE_RIGHT
      })
    })]
  });
});
NoteTextField.displayName = "NoteTextField";
export default NoteTextField;